import { monthFromDate, monthToDate } from './monthKey';

/**
 * The arguments the JOBS BOARD sends to `fetchJobs`.
 *
 * One place, because there are four call sites — mount and manual refresh, on both the
 * kanban board and the split view — and they must not drift. They did not exist as a
 * shared thing when the board only sent a month, and that is how the bug below was
 * able to be fixed in one of them and not the others.
 *
 * ⚠️ `includeOpenJobs` is the whole point of this helper. The month window filters on
 * a job's SCHEDULED date, so a booking taken on the 31st for the 1st of next month
 * produced a job that showed in no column at all — an empty Queued lane with a car
 * booked in for the morning — and a job still in progress dropped off the board at
 * midnight on the 1st. With the flag the window bounds only the FINISHED jobs and open
 * work is always on the board.
 *
 * Which statuses count as "open" is deliberately NOT decided here. The server owns
 * that rule and applies it in the query; re-deriving it in the client would be a
 * second, weaker copy that goes wrong the moment a status is added.
 *
 * @param {{ selectedMonth: string, myJobsOnly?: boolean, bustCache?: boolean }} options
 * @returns {object} arguments for the `fetchJobs` thunk
 */
export const jobsBoardQuery = ({ selectedMonth, myJobsOnly = false, bustCache = false }) => ({
    fromDate: monthFromDate(selectedMonth),
    toDate: monthToDate(selectedMonth),
    myJobsOnly,
    includeOpenJobs: true,
    ...(bustCache ? { bustCache: true } : {}),
});

export default jobsBoardQuery;
